import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DuplicateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Duplicate",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.7 23.78h.59c-.04-.13-.06-.27-.06-.4V9.25a3.1 3.1 0 0 1 3.12-3.1h10.4v-.53c0-2-1.64-3.62-3.64-3.62H7.7c-2 0-3.62 1.62-3.63 3.62v14.53c0 2 1.63 3.62 3.63 3.63M20.16 8.21h-6.23c-2 0-3.62 1.63-3.63 3.63v14.53c0 2 1.63 3.62 3.63 3.63H24.3c2 0 3.62-1.63 3.63-3.63V11.85a3.65 3.65 0 0 0-3.63-3.63h-4.14Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25 28H13c-1.65 0-3-1.35-3-3V13c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3v12c0 1.65-1.35 3-3 3M13 12c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V13c0-.55-.45-1-1-1z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7 22c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3 0 .55-.45 1-1 1s-1-.45-1-1-.45-1-1-1H7c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1"
      })]
    })
  }));
};